export var FormConstants = {
    FieldIsRequired: 'Field is required'
};
